import { render, staticRenderFns } from "./TheWallTabButton.vue?vue&type=template&id=3083d23f&scoped=true&"
import script from "./TheWallTabButton.vue?vue&type=script&lang=js&"
export * from "./TheWallTabButton.vue?vue&type=script&lang=js&"
import style0 from "./TheWallTabButton.vue?vue&type=style&index=0&id=3083d23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083d23f",
  null
  
)

export default component.exports